<template>
  <div class="modal-card">
    <div class="row-width-actions-bar is-border-bottom">
      <div class="columns is-gapless is-vcentered">
        <div class="column is-padding-left is-narrow">
          <span class="icon is-medium"><i class="fal fa-crop"></i></span>
        </div>
        <div class="column is-padding-left-xxsmall">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Édition d'une image</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click.prevent.stop="close()"
            aria-label="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>

    <section class="modal-card-body">
      <form
        @submit.prevent.stop="submit"
        id="formDocumentModalEdit">
        <div class="columns">
          <div
            class="column"
            :class="{'cropper-circle':circle}">
            <vue-cropper
              :src="source.path"
              :drag-mode="'none'"
              :aspect-ratio="ratio"
              :zoomable="false"
              ref="cropper"></vue-cropper>
          </div>
        </div>
      </form>
    </section>
    <footer class="modal-card-foot">
      <button
        @click.prevent.stop="close"
        class="button">
        Annuler
      </button>
      <button
        type="submit"
        class="button is-primary"
        form="formDocumentModalEdit">
        Enregistrer
      </button>
    </footer>
  </div>
</template>

<script>
import 'cropperjs/dist/cropper.css'

export default {
  name: 'DocumentModalEdit',
  components: {
    VueCropper: () => import('vue-cropperjs')
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    ratio: {
      type: Number
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submit () {
      let cropImg = this.dataURItoBlobtoFile(this.$refs.cropper.getCroppedCanvas().toDataURL({ format: 'jpeg' }))
      let newfile = new FormData()

      let name = this.source.filename
      let ext = this.source.path.split('.')
      if (!name.split('.')[name.split('.').length - 1].match(/(jpg|png|jpeg|gif)/g)) name += `.${ext[ext.length - 1]}`

      newfile.append('file[]', cropImg, name)
      newfile.cropped = true
      this.$emit('submit', newfile)
      this.$emit('close')
    },
    close () {
      this.$emit('close')
    },
    dataURItoBlobtoFile (dataURI, callback) {
      const byteString = atob(dataURI.split(',')[1])
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      const ab = new ArrayBuffer(byteString.length)
      const ia = new Uint8Array(ab)
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      const bb = new Blob([ab], { type: mimeString })
      const nF = new File([bb], this.source.filename, { type: mimeString })
      return nF
    }
  }
}
</script>
